import { styled } from '@mui/material';
import { CoreDialogTitle } from '@youscience/core';

export const sxStyles = {
  dialogWrap: {
    '.MuiPaper-root': {
      borderRadius: '12px',
    },
  },
};

export const StyledDialogTitle = styled(CoreDialogTitle)(({ theme }) => ({
  ...theme.typography.h4,
  borderBottom: `1px solid ${theme.palette.grey['300']}`,
}));

export const StyledDialogContent = styled('div')(({ theme }) => ({}));

export const StyledContainer = styled('div')(() => {
  return {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '1rem',
    borderWidth: '2px',
    borderRadius: '2px',
    borderStyle: 'dashed',
    backgroundColor: '#fafafa',
    outline: 'none',
    transition: 'border .24s ease-in-out',

    '&.drag-active': {
      backgroundColor: '#cdcdcd',
    },
  };
});
